var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThumbUpFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.002 11.066c-.47-.661-1.316-.945-2.162-.945h-3.572l1.692-4.914c.094-.567 0-1.134-.282-1.512-.376-.472-.94-.756-1.504-.756-.564 0-1.128.283-1.41.661L7.782 9.366c-.47.472-.752.945-.94 1.606H5.62c-1.504 0-2.726 1.134-2.726 2.552v5.386c0 1.418 1.222 2.552 2.726 2.552h11.092c1.316 0 2.444-.945 2.632-2.174l1.128-6.237c.188-.661 0-1.417-.47-1.984z"
  })));
}
export default SvgThumbUpFilled;